import React from 'react';
import { useNavigate } from 'react-router-dom';

const CategoryCard = ({ category }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/category/${category.id}`);
  };

  return (
    <div
      onClick={handleClick}
      className="relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer group"
    >
      <img
        src={category.image}
        alt={category.name}
        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-3">
        <h3 className="text-white font-semibold text-xs sm:text-sm leading-snug line-clamp-2">
          {category.name}
        </h3>
      </div>
    </div>
  );
};

export default CategoryCard;